import * as z from 'zod'

export const stringNumberSchema = z.union([
  z.number(),
  z.string().transform((val, ctx) => {
    const parsed = parseInt(val)

    if (Number.isNaN(parsed)) {
      ctx.addIssue({ code: 'custom', message: 'Not a number' })
      return z.NEVER
    }
    return parsed
  }),
])

export const checkboxValueSchema = z.object({
  checked: z.boolean(),
  score: z.number(),
})
